module.exports = __webpack_public_path__ + "static/media/ProfLindaXiao.3c6541e3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/comp/sub1/ProfLindaXiao.jpg
// module id = 199
// module chunks = 0